<template>
  <q-form @submit="this.onSubmit" class="form">
    <div class="form__item">
      <CustomInput label="Название блока" :value="this.formData.block_name"
        @change_input="(value) => onChange('block_name', value)" required />
    </div>
    <CustomModalFooter :btn-loading="this.loading" />
  </q-form>
</template>
<script>

import CustomInput from "@/components/form/CustomInput";
import CustomModalFooter from "@/components/modal/modals/modal-footer";

export default {
  name: "add-block",
  components: { CustomModalFooter, CustomInput },
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        block_id: this.data?.body?.block_id || null,
        resident_id: this.data?.body?.resident_id || '',
        block_name: this.data?.body?.block_name || '',
      }
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit(this.formData)
      this.loading = false
    },
  }
}
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  width: 400px;
  gap: 15px;

  @media (max-width: 460px) {
    width: 100%;
  }
}
</style>
